import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    value: [{ name: "HOME", link: "/" }],
}

const preset = {
    "/review": { name: "리뷰", link: "/review/list" },
    "/review/write": { name: "리뷰 작성", link: "/review/write" },
    "/review/detail": { name: "리뷰 작성", link: "/review/detail" },
    "/review/result": { name: "받은 리뷰", link: "/review/result/list" },
    "/review/result/detail": { name: "리뷰 결과 조회", link: "/review/result/detail" },

    "/group": { name: "그룹", link: "/group/list" },
    "/group/detail": { name: "그룹 정보", link: "/group/detail" },

    // "/admin": { name: "관리자", link: "/admin/review/list" },
    "/admin/review": { name: "리뷰 (관리)", link: "/admin/review/list" },
    "/admin/review/detail": { name: "리뷰 수정", link: "/admin/review/detail" },
    "/admin/review/create": { name: "리뷰 생성", link: "/admin/review/create" },
    // "/admin/review/result": { name: "리뷰 결과", link: "/admin/review/result/list" },
    "/admin/review/result/detail": { name: "리뷰 결과 조회", link: "/admin/review/result/detail" },

    "/admin/group": { name: "그룹 (관리)", link: "/admin/group/list" },
    "/admin/group/create": { name: "그룹 생성", link: "/admin/group/create" },
    "/admin/group/detail": { name: "그룹 정보", link: "/admin/group/detail" },

    "/admin/user/list": { name: "유저 (관리)", link: "/admin/user/list" },
}

export const categorySlice = createSlice({
    name: "category",
    initialState,
    reducers: {
        setCategory: (state, action) => {
            const urlArr = action.payload.split("/").filter(Boolean)

            let list = [{ name: "HOME", link: "/home" }]
            let currentPath = ""

            for (let i = 0; i < urlArr.length; i++) {
                currentPath += `/${urlArr[i]}`

                const presetItem = preset[currentPath]
                if (presetItem) {
                    let to = presetItem.link
                    let j = i + 1
                    while (j < urlArr.length) {
                        const seg = urlArr[j]
                        const nextPath = `${currentPath}/${seg}`

                        // 다음 Path가 preset에 있거나 seg가 list, result 같은 static 페이지라면 붙이지 않고 중단
                        if (preset[nextPath] || seg === "list"  || seg === "result") break

                        to += `/${seg}`
                        j++
                    }

                    list.push({
                        name: presetItem.name,
                        link: to
                    })
                }
            }

            state.value = list
        },
    },
})

export const { setCategory } = categorySlice.actions
export default categorySlice.reducer